import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";

import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "../../../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import Loader from "../../common/loader/Loader";
import "./OfficeList.css";

function OfficeList(props) {
  const [offices, setOffices] = useState();
  const [redirect, setRedirect] = useState(null);
  const [showInfo] = useState(true);
  const [renderShowsTotal] = useState(true);
  const [selectedOffice, setSelectedOffice] = useState(props.initialValue);
  const [isLoading, setIsLoading] = useState();

  useEffect(() => {
    setSelectedOffice(props.initialValue);
  }, [props.initialValue]);

  const handleIdLineTypeChange = (event, newValue) => {
    props.setIdOfficeOnMem(event.target.value, props.row);

    setSelectedOffice(newValue.props.value);
  };
  const useStyles = makeStyles({
    root: {
      width: "100%",
      overflowX: "auto",
    },
    table: {
      minWidth: 230,
    },
    tableHead: {
      background: "#3f51b5",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "darkcyan !important",
      },
    },

    tableRow: {
      "&:hover": {
        backgroundColor: "lightgrey !important",
      },
    },
    headerCell: {
      color: "white",
    },
  });

  const classes = useStyles();

  useEffect(() => {
    //Change for server api address
    setIsLoading(true);
    //Profile Props',props )
    const url = process.env.REACT_APP_API2_URL + "/Player/GetOffice";

    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        setOffices(data);
        setIsLoading(false);

        props.setIdOfficeOnMem(selectedOffice);
      });
  }, []);

  function selectedValues(row) {
    setRedirect(row);
  }

  const options = {
    page: 1, // which page you want to show as default
    sizePerPageList: [
      {
        text: "15",
        value: 15,
      },
      {
        text: "50",
        value: 50,
      },
      {
        text: "500",
        value: 500,
      },
      {
        text: "1000",
        value: 1000,
      },
    ], // you can change the dropdown list for size per page
    sizePerPage: 28, // which size per page you want to locate as default
    pageStartIndex: 1, // where to start counting the pages
    paginationSize: 1, // the pagination bar size.
    prePage: "<", // Previous page button text
    nextPage: ">", // Next page button text
    firstPage: "First", // First page button text
    lastPage: "Last", // Last page button text
    paginationShowsTotal: renderShowsTotal, // Accept bool or function
    paginationPosition: "bottom", // default is bottom, top and both is all available
    // hideSizePerPage: true > You can hide the dropdown for sizePerPage
    // alwaysShowAllBtns: true // Always show next and previous button
    withFirstAndLast: false, // > Hide the going to First and Last page button
    //expandRowBgColor: 'rgb(196, 222, 222)',
    // afterDeleteRow: onAfterDeleteRow, // A hook for after droping rows.
    //handleConfirmDeleteRow: customConfirm,
    onRowClick: selectedValues,
  };

  const cellEditProp = {
    mode: "click", //DBClick daba problemas con el Expand se cambio a click
    beforeSaveCell: onBeforeSaveCell, // a hook for before saving cell
    //afterSaveCell: onAfterSaveCell, // a hook for after saving cell
  };

  function onBeforeSaveCell() {
    // You can do any validation on here for editing value,
    // return false for reject the editing
    return true;
  }
  const printInputList = () => {
    return (
      <div>
        <FormControl
          className={`${classes.formControl} w-full`}
          size="small"
          variant="outlined"
        >
          <InputLabel shrink id="demo-simple-select-placeholder-label-label">
            Office
          </InputLabel>
          <Select
            labelId="demo-simple-select-placeholder-label-label"
            id="demo-simple-select-placeholder-label"
            value={selectedOffice}
            onChange={handleIdLineTypeChange}
            displayEmpty
            className={`${classes.selectEmpty} w-full`}
          >
            {offices &&
              offices.map((row) => (
                <MenuItem value={row.idOffice} key={row.idOffice}>
                  {row.officeName}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </div>
    );
  };
  const printList = () => {
    return (
      <div id="main-div profile-list" class="profile-list">
        <Paper className={classes.root}>
          <h2>Offices</h2>

          {isLoading ? <Loader></Loader> : ""}
          <Table className={classes.table} aria-label="simple table">
            <TableBody className={showInfo ? "show-table" : "hide-table"}>
              {offices && (
                <div>
                  <BootstrapTable
                    pagination={true}
                    options={options}
                    cellEdit={cellEditProp} //DBClick daba problemas con el Expand
                    version="4"
                    data={offices}
                    // deleteRow={true}
                    hover
                  >
                    <TableHeaderColumn
                      isKey={true}
                      filter={{ type: "TextFilter", delay: 1000 }}
                      dataField="OfficeName"
                    >
                      OfficeName
                    </TableHeaderColumn>
                  </BootstrapTable>
                </div>
              )}
            </TableBody>
          </Table>
        </Paper>
      </div>
    );
  };

  if (redirect) {
    let pushURL = "/lineType/" + redirect.IdLineType;
    props.setLineType(redirect);
    printList();
    setRedirect(null);
    return (
      <div>
        <Redirect
          to={{
            pathname: pushURL,
          }}
        />

        {}
      </div>
    );

    //history.push(pushURL);
  }

  if (props.isInput) {
    return printInputList();
  } else {
    return printList();
  }
}

export default OfficeList;
